import * as React from 'react';
import { Snackbar, IconButton } from '@mui/material';

export type Props = {
	new?: boolean
	message?:string
	consume?:Function
};

export default class Toast extends React.Component<Props> {
	private handleClose = () => {
		this.props.consume();
	}

	render = () => <Snackbar open={!!this.props.message} key={Date.now()} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} message={this.props.message} autoHideDuration={3000} onClose={this.handleClose} action={
		<IconButton size="small" aria-label="close" color="inherit" onClick={this.handleClose}>
			<i className="material-icons">close</i>
		</IconButton>
	}/>
}